/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {

  app.CartGiftMessageView = app.View.extend({

    events: {
      'click .js-close': 'closeGiftMessage',
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.giftMessageId = null;
      this.giftMessageTemplate = app.helpers.TemplateHelper.getTemplate('#gifts-message-template');
    },

    /**
     * Получение коллекции доступных пользователю сетов подарков за действие
     */
    fetchAvailableGifts: function () {
      this.collection.fetch({
        headers: {
          Authorization: 'Bearer ' + this.user.get('jwtToken'),
        },
        data: {
          user_id: this.user.get('id'),
          has_present: 1
        },
        success: this.renderGiftMessage.bind(this),
      });
    },

    /**
     * Отрисовка сообщения о наличии подарка
     * @param {Object} sets Сеты доступных подарков за действие
     */
    renderGiftMessage: function (sets) {
      var setId = sets && sets.length && sets.models && sets.models[0] ? sets.models[0].get('id') : null;
      if (this.giftMessageId !== setId) {
        this.giftMessageId = setId;
        this.$el.html(setId ? this.giftMessageTemplate({set_id: setId}) : '');
        if (!app.isMobile) {
          Backbone.trigger('cart-aside:need-update-margin');
        }
      }
    },

    /**
     * Закрытие информирующего о наличии подарка за дейстие сообщения
     */
    closeGiftMessage: function () {
      this.$el.html('');
      if (!app.isMobile) {
        Backbone.trigger('cart-aside:need-update-margin');
      }
    },
  });
})();

}.call(window));